import SkierTypes from "./SkierTypes";


export default {
    name     : 'dialog_skier_types',
    component: SkierTypes,
    dialog   : {
        'max-width': "500px"
    }
}
